import React from 'react';
import { useHistory } from 'react-router-dom';
import PATH from 'routes/paths';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { authUserSelector } from 'store/auth/selectors';
import RoleModel from 'api/models/RoleModel';
import Dropdown from 'stories/ui/Dropdown/Dropdown';
import PropTypes from 'prop-types';
import NavigationDropdownIcon from '../../stories/ui/Icons/NavigationDropdownIcon';

const NavigationDropdown = ({ options, onChange }) => {
  const history = useHistory();
  const { t } = useTranslation();
  const authUser = useSelector(authUserSelector);
  const isCoordinator = RoleModel.authUserIs(
    authUser,
    RoleModel.ROLES.COORDINATOR
  );

  const adminOptions = [
    // Overview
    {
      option: t('project.dashboard.itself'),
      onClick: () => history.push(PATH.DASHBOARD),
    },
    {
      option: t('project.projects'),
      onClick: () => history.push(PATH.PROJECT.LIST),
    },
    // Operational
    ...(!isCoordinator
      ? [
          {
            option: t('internalRequest.plural.itself'),
            onClick: () => history.push(PATH.INTERNAL_REQUEST.LIST),
          },
        ]
      : []),
    // People & Entities
    {
      option: t('user.plural.itself'),
      onClick: () => history.push(PATH.USER.LIST),
    },
    {
      option: t('realm.plural.itself'),
      onClick: () => history.push(PATH.ORGANIZATION.LIST),
    },
    {
      option: t('subcontractor.plural.itself'),
      onClick: () => history.push(PATH.SUBCONTRACTOR.LIST),
    },
    // Communication
    {
      option: t('announcement.plural.itself'),
      onClick: () => history.push(PATH.ANNOUNCEMENT.LIST),
    },
    {
      option: t('chat.itself'),
      onClick: () => history.push(PATH.CHAT.PROJECT_CHANNEL.LIST),
    },
    // Configuration
    {
      option: t('project.standardProcedures'),
      onClick: () => history.push(PATH.STANDARD.PROCEDURE.LIST),
    },
    {
      option: t('units.itself'),
      onClick: () => history.push(PATH.UNITS.LIST),
    },
    ...(!isCoordinator
      ? [
          {
            option: t('general.settings'),
            onClick: () => history.push(PATH.SETTINGS.INTERNAL_REQUESTS),
          },
        ]
      : []),
  ];

  return (
    <Dropdown
      onMenuItemSelected={onChange}
      options={options.length ? options : adminOptions}
      nestedLevelsContainerHoverDirection="right"
      icon={NavigationDropdownIcon}
    />
  );
};

NavigationDropdown.propTypes = {
  options: PropTypes.arrayOf([PropTypes.instanceOf(Object)]),
  onChange: PropTypes.func,
};

NavigationDropdown.defaultProps = {
  options: [],
  onChange: () => {},
};

export default NavigationDropdown;
